/* eslint-disable react/prop-types */
const CloudDownloadIcon = ({ className, stroke = "#000", size = "24px" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M8 17l4 4 4-4" />
      <path d="M12 12v9" />
      <path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29" />
    </svg>
  );
};

export default CloudDownloadIcon;